function redirectToDonation() {
    window.location.href = 'https://secure.actblue.com/donate/ren4mi';
}

export default redirectToDonation;